module.exports = __webpack_public_path__ + "static/img/mobile_work_order_mgr.ef11b912.png";